
import { Component, OnInit, OnDestroy, Input } from '@angular/core';
import { UntypedFormGroup, FormControl, Validators, UntypedFormBuilder } from '@angular/forms';

import { takeUntil } from 'rxjs/operators' ;  import { Subject } from 'rxjs';
//shared libs

//services
import { TranslateService } from '@ngx-translate/core';
import { UserSessionService, ControlsParams } from '../../shared';
import { User, UserService } from '../userData';
import { AppCodeGroup } from '../../common';

@Component({
    selector: 'ChangePassword',
    templateUrl: './change-password.component.html'
})


export class ChangePasswordComponent implements OnInit, OnDestroy {
    master: any = <any>{};
    editUser: User = <User>{};
    userForm: UntypedFormGroup;
    controlsParams: ControlsParams;
    userData: any = <any>{};
    private ngUnsubscribe: Subject<void> = new Subject<void>();

    constructor(
        private _userService: UserService,
        private _fb: UntypedFormBuilder,
        private _userSessionService: UserSessionService,
        public translate: TranslateService) {
        this.controlsParams = new ControlsParams(555, AppCodeGroup.Buttons, true);
    }

    ngOnInit() {
        this.UserInit();
        // for first time get model key by this way and get seclogins after it
        this.master = this._userSessionService.getModalKey('ChangePasswordComponent')['inputs'];
        this.getUser(this.master.userID);
        //this.getUserData();
        // second subscribe to model key to get data continiously
        this._userSessionService.getModalKey$().pipe(
            takeUntil(this.ngUnsubscribe))
            .subscribe((keys: any) => {
                this.master = <any>{};
                if (keys.name == 'ChangePasswordComponent' && keys.inputs) {
                    this.master = keys.inputs;
                    this.getUser(this.master.userID);
                    this.getUserData();
                }
            });
    }

    getUserData() {
        if (this.userForm) {
            this.userForm.reset();
            this.userForm.patchValue(this.editUser);
        }
    }

    ngOnDestroy() {
        this.ngUnsubscribe.next();
        this.ngUnsubscribe.complete();
        this.resetForm();
    }

    // initialize SecLogins form
    UserInit() {
        this.userForm = this._fb.group({
            userID: [0],
            empID: [0],
            admin: 0,
            defaultLang: 0,
            secondLang: 0,
            userName: [''],
            workEncrypLink: 0,
            active: [1],
            defaultGroup: [''],
            defaultBranch: [''],
            password: ['', Validators.required],
            newPassword: ['', Validators.required],
            confirmPassword: ['', Validators.required],
        })
    }
    resetForm() {
        this.userForm.reset();
    }

    onClicked(e: number): void {
        switch (e) {
            case 1: //save code
                this.save();
                break;
        }
    }

    getUser(userId: number) {
        if (userId) {
            this._userService.getUser(userId)
                .subscribe(
                    user => {
                        this.editUser = user.data[0];
                        this.editUser.password = null;
                        this.userForm.get('newPassword').setValue(null);
                        this.userForm.get('confirmPassword').setValue(null);
                        this.userForm.patchValue(this.editUser);
                    }
                ),
                error => console.log(error),
                () => {
                    //this._userSessionService.setSessionKey("editUserPassEnc", this.editUser.password);
                    this.editUser.password = null;
                    this.userForm.get('newPassword').setValue(null);
                    this.userForm.get('confirmPassword').setValue(null);

                    this.userForm.patchValue(this.editUser);
                }
        }
    }

    //#region Crud operations

    save() {
        this.editUser = this.userForm.value;
        this.editUser.userID = this.master.userID;
        this.editUser.password = this.userForm.get('newPassword').value;
        this.editUser.pass = this.userForm.get('newPassword').value;
        // this.editUser.empId = this.userForm.get('empId').value;
        // this.editUser.empId = this.master.empId;


        if (this.editUser.userID != null) {
            this._userService.updateUser(this.editUser).pipe(
                takeUntil(this.ngUnsubscribe))
                .subscribe(c => {
                    if (c && c.returnFlag == true) { }
                });
        }
    }
}